import { render } from "./JobInfo.vue?vue&type=template&id=16770a9a&scoped=true&ts=true"
import script from "./JobInfo.vue?vue&type=script&lang=ts"
export * from "./JobInfo.vue?vue&type=script&lang=ts"

import "./JobInfo.vue?vue&type=style&index=0&id=16770a9a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16770a9a"]])

export default __exports__